import { Hubspot } from '@clearkit/icons';
import { CKBadge } from 'clearkit';

export const HubSpotBadge = () => (
  <CKBadge className="inline-flex gap-1 bg-hubspot">
    <Hubspot className="w-3 h-3" />
    In HubSpot
  </CKBadge>
);
